import { render } from "./big.vue?vue&type=template&id=57b813bc&scoped=true"
import script from "./big.vue?vue&type=script&lang=js"
export * from "./big.vue?vue&type=script&lang=js"

import "./big.vue?vue&type=style&index=0&id=57b813bc&lang=scss&scoped=true"
import "./big.vue?vue&type=style&index=1&id=57b813bc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b813bc"]])

export default __exports__